<template>
    <div class="content">
        <h2>行政处罚事先告知书审批表</h2>
        
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <!--<el-col :span="24">
                    <el-form-item label="文号:" prop="wenhao">
                        <el-input style="width:200px; margin-right:10px;"
                        v-model="form.wenhao"
                        placeholder="请输入"
                        clearable
                        size="small"
                        />
                        <el-button type="warning" size="small" @click="getWh(1)">获取编号</el-button>
                    </el-form-item>
                </el-col>-->
                <el-col :span="24">
                    <el-form-item label="案由:" prop="anyou">
                        <el-input
                        v-model="form.anyou"
                        placeholder="请输入案由"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <!--<el-col :span="24">
                    <el-form-item label="处罚决定文号:" prop="cfjdsWh">
                        <el-input
                        v-model="form.cfjdsWh"
                        placeholder="请输入处罚决定文号"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>-->
                <el-col :span="24">
                    <el-form-item label="违法事实:" prop="wfss">
                        <el-input type="textarea" rows="3"
                        v-model="form.wfss"
                        placeholder="请输入违法事实"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="主体资格证据:" prop="ztzgzj">
                        <el-input type="textarea" rows="3"
                        v-model="form.ztzgzj"
                        placeholder="请输入主体资格证据"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="违法事实证据:" prop="wfsszj">
                        <el-input type="textarea" rows="3"
                        v-model="form.wfsszj"
                        placeholder="请输入违法事实证据"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <!--<el-col :span="24">
                    <el-form-item label="违反法律:" prop="dxyj">
                        <el-input type="textarea" rows="3"
                        v-model="form.dxyj"
                        placeholder="请输入违反法律"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>-->
                <el-col :span="24">
                    <el-form-item label="处罚依据:" prop="clyj">
                        <el-input type="textarea" rows="3"
                        v-model="form.clyj"
                        placeholder="请输入处罚依据"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                <!--<el-col :span="24">
                    <el-form-item label="行政处罚法:" prop="xingzhengchufafa">
                        <el-input type="textarea" rows="3"
                        v-model="form.xingzhengchufafa"
                        placeholder="请输入行政处罚法"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>-->
                <el-col :span="24">
                    <el-form-item label="处罚内容:" prop="chufaneirong">
                        <el-input type="textarea" rows="5"
                        v-model="form.chufaneirong"
                        placeholder="请输入处罚内容"
                        clearable
                        size="small"
                        />
                    </el-form-item>
                </el-col>
                
                <!--<el-col :span="24">
                    <el-form-item label="签名方式:" prop="qmfs">
                        <el-radio-group v-model="form.qmfs">
                            <el-radio :label="1">电子签名及日期</el-radio>
                            <el-radio :label="2">手工签名无日期</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>-->
                <el-col :span="24">
                    <el-form-item label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit('form')">生成行政处罚事先告知书审批表</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <!--<el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>-->
                    </el-form-item>
                </el-col>
            </el-row>            
        </el-form>


        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="行政处罚事先告知书审批表" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    props:['code','pcId','ajdcbg','ajsl','xwbl','xzcfsxgzsspbList','anyou'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            sheng:'',
            xianqu:'',
            jcjg:'',
            form:{
                xzcfsxgzspb_lsh:'',
                wenhao:'',
                anyou:'',
                cfjdsWh:'',
                wfss:'',
                ztzgzj:'',
                wfsszj:'',
                dxyj:'',
                clyj:'',
                xingzhengchufafa:'',
                chufaneirong:'',
            },
            rules:{
                wenhao:[
                    { required: true, message: '文号不能为空', trigger: 'blur' }
                ],
                anyou:[
                    { required: true, message: '案由不能为空', trigger: 'blur' }
                ],
                cfjdsWh:[
                    { required: true, message: '处罚决定文号不能为空', trigger: 'blur' }
                ],
                wfss:[
                    { required: true, message: '违法事实不能为空', trigger: 'blur' }
                ],
                ztzgzj:[
                    { required: true, message: '主体资格证据不能为空', trigger: 'blur' }
                ],
                wfsszj:[
                    { required: true, message: '违法事实证据不能为空', trigger: 'blur' }
                ],
                dxyj:[
                    { required: true, message: '违反法律不能为空', trigger: 'blur' }
                ],
                clyj:[
                    { required: true, message: '处罚依据不能为空', trigger: 'blur' }
                ],
                xingzhengchufafa:[
                    { required: true, message: '行政处罚法不能为空', trigger: 'blur' }
                ],
                chufaneirong:[
                    { required: true, message: '处罚内容不能为空', trigger: 'blur' }
                ],
                qmfs:[
                    { required: true, message: '签名方式不能为空', trigger: 'blur' }
                ]
            },
            open:false,
            form2:{
                jcnr:''
            },
            wsUrl:'',
            isWs:false,
            jdyOptions:[],
            jdyZfz1:'',
            jdyZfz2:'',            
            zfmbList:[],
            isActive:'0',
            isActive2:'-1',
            zfXX:[],
            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    async created() {
      
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.sheng = user.sheng
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.jcjg = user.jcjg
        this.baseUrl = user.baseUrl

        this.getList()    
    },
    async mounted() {
    },
    methods: {
        getList(){
            if(this.xzcfsxgzsspbList){
                this.form = this.xzcfsxgzsspbList
                this.isWs = true
                this.wsUrl = this.xzcfsxgzsspbList.url
                this.$forceUpdate()
            }else{
                let ay = this.anyou ? this.anyou : ''
                this.$set(this.form,'anyou',ay)
                if(this.ajdcbg){
                    let ztzgzj = this.ajdcbg.ztzgzj ? this.ajdcbg.ztzgzj : ''
                    this.$set(this.form,'ztzgzj',ztzgzj)
                    let wfsszj = this.ajdcbg.wfsszj ? this.ajdcbg.wfsszj : ''
                    this.$set(this.form,'wfsszj',wfsszj)
                    let clyj = this.ajdcbg.cfyj ? this.ajdcbg.cfyj : ''
                    this.$set(this.form,'clyj',clyj)
                    
                    if(this.ajdcbg.data.length>0){
                        let arr = this.ajdcbg.data
                        let falv = ''
                        let cfyj = ''
                        let wfss = ''
                        let nycf = ''
                        arr.forEach((item,index) => {
                            falv += item.wffl + (index < arr.length - 1 ? '；' : '')
                            cfyj += item.cfyj + (index < arr.length - 1 ? '；' : '')
                            wfss += item.wfxw + (index < arr.length - 1 ? '；' : '')
                            nycf += item.nycf + (index < arr.length - 1 ? '；' : '')
                        })
                        this.$set(this.form,'dxyj',falv)
                        this.$set(this.form,'clyj',cfyj)  
                        this.$set(this.form,'wfss',wfss)  
                        this.$set(this.form,'chufaneirong',nycf)                    
                    }
                }
            }             
        },
        getWenshu(){  
            this.isWs = false 
            axios({
                method: 'post',
                url: this.baseUrl+`/xx/selectWenshu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh: this.pcId,
                    wsName:'行政处罚事先告知书审批表'
                }
            })
            .then(response => {
                if(response.data.code==0){
                    if(response.data.msg){ 
                        this.isWs = true
                        let ws = response.data.msg
                        this.wsUrl = ws
                    }else{
                        this.isWs = false
                    }
                }else{
                    this.isWs = false
                }
            })
            .catch(error => {
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });          
        },
        async getWh(val){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblBh&id=${this.pcId}`)
            if(data.data){
                if(data.data.errMessage){
                    this.$set(this.form,'wenhao',data.data.errMessage)
                }else{
                    let bh = new Date().getFullYear() + '-'
                    this.$set(this.form,'wenhao',bh)
                }
            }
        },

        show(){
            if(this.wsUrl){
                let ws = this.wsUrl
                if(ws){
                    let url = this.$router.resolve({
                        path:'/pdf2',
                        query:{
                            wsname:'xzcfsxgzsspb',
                            ws:encodeURIComponent(ws) // 手动 encode 一次
                        }
                    })
                    window.open(url.href,'_blank')
                }else{
                    this.$message.error('暂未制作本文书，不能预览！') 
                }
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                let url = this.wsPdf
                window.open(url,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            let wsname = 'anjianshoulijilu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.form2.jcnr.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            if(itema.mc.indexOf('<br/>') != -1){
              itema.mc = itema.mc.replace(/<br\s*\/?>/gi, '\n');
            }
            if(this.form2.jcnr){
              let zf = this.form2.jcnr.substr(this.form2.jcnr.length - 1,1)
              let nr = zf != '\n' ? '\n' +  itema.mc : itema.mc
              this.form2.jcnr =  this.form2.jcnr + nr
            }else{
              this.form2.jcnr = itema.mc
            }
          }
        },
        submit(form){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log(this.form,725)
                    let that = this
                    this.loading = true

                    axios({
                        method: 'post',
                        url: this.baseUrl+`/xx/makeWenshu`,
                        data:{
                            lsh: this.pcId,
                            wsName:'行政处罚事先告知书审批表',
                            xzcfsxgzspbLsh:this.form.xzcfsxgzsspb_lsh,
                            //wenhao:this.form.wenhao,
                            anyou:this.form.anyou,
                            //cfjdsWh:this.form.cfjdsWh,
                            wfss:this.form.wfss, 
                            ztzgzj:this.form.ztzgzj,
                            wfsszj:this.form.wfsszj,
                            dxyj:this.form.dxyj,
                            clyj:this.form.clyj,
                            //xingzhengchufafa:this.form.xingzhengchufafa,
                            chufaneirong:this.form.chufaneirong,
                            qtspsx:this.form.qtspsx,                                                      
                            //qmfs:this.form.qmfs,                           
                            cmid:this.cmid,
                            xm:this.xm,
                            dm:this.dm,
                            shi:this.shi,
                            xianqu:this.xianqu,
                            jcjg:this.jcjg
                        },
                        headers: { 
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        console.log(res,809)
                        this.loading = false
                        if(res.data.code == 0 && res.data.data){
                            this.isWs = true
                            this.wsUrl = res.data.data.url
                            this.$set(this.form,'xzcfsxgzsspb_lsh',res.data.data.lsh)
                            
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.show()
                        }else{
                            if(res.data.msg){
                                this.$message.error(res.data.msg)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                    
                }
            })
        }
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.content >>> .el-textarea.is-disabled .el-textarea__inner ,.content >>> .el-input.is-disabled .el-input__inner{ color: #333;}
.zfmb{ border:1px solid #DCDFE6; padding: 20px;max-height: 500px; overflow-y: auto;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../../assets/images/wjj.png) no-repeat center left; margin-left: 10px;}
.zfmb2 span.dqSpan{color:#0C80E8;}
.zfmb2 span b{ display: none; position: absolute; top:40px;left: 120px; width: 600px; font-weight: normal; background:#303133; color: #fff;padding: 5px 10px;
    border-radius: 6px;}
.zfmb2 span:hover b{ display: block;}
.content >>> .el-form-item {
    margin-bottom: 12px !important;
}
</style>